import React from "react";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import { User } from "../../utils/supabase";

export interface KanbanFilterState {
  priority: string;
  type: string;
  assignedTo: string;
  search: string;
}

interface KanbanFiltersProps {
  filters: KanbanFilterState;
  onFilterChange: (filters: KanbanFilterState) => void;
  users: User[];
}

export default function KanbanFilters({ filters, onFilterChange, users }: KanbanFiltersProps) {
  const update = (partial: Partial<KanbanFilterState>) =>
    onFilterChange({ ...filters, ...partial });

  return (
    <div className="bg-white p-3 rounded-lg shadow-sm border border-gray-200 mb-4">
      <div className="grid grid-cols-1 md:grid-cols-5 gap-3">
        {/* Search */}
        <div className="md:col-span-2">
          <div className="relative">
            <MagnifyingGlassIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
            <input
              type="text"
              placeholder="Zoeken..."
              value={filters.search}
              onChange={(e) => update({ search: e.target.value })}
              className="pl-9 block w-full border-gray-300 rounded-md focus:ring-primary-500 focus:border-primary-500 sm:text-sm"
            />
          </div>
        </div>

        {/* Priority Filter */}
        <div>
          <select
            value={filters.priority}
            onChange={(e) => update({ priority: e.target.value })}
            className="block w-full border-gray-300 rounded-md focus:ring-primary-500 focus:border-primary-500 sm:text-sm"
          >
            <option value="all">Alle prioriteiten</option>
            <option value="urgent">Urgent</option>
            <option value="high">Hoog</option>
            <option value="medium">Gemiddeld</option>
            <option value="low">Laag</option>
          </select>
        </div>

        {/* Type Filter */}
        <div>
          <select
            value={filters.type}
            onChange={(e) => update({ type: e.target.value })}
            className="block w-full border-gray-300 rounded-md focus:ring-primary-500 focus:border-primary-500 sm:text-sm"
          >
            <option value="all">Alle types</option>
            <option value="communication">Communicatie</option>
            <option value="calibration">Kalibratie</option>
            <option value="expiry_check">Houdbaarheidcontrole</option>
            <option value="complaint">Klacht</option>
            <option value="orders">Bestellingen</option>
            <option value="other">Overig</option>
          </select>
        </div>

        {/* Assigned To Filter */}
        <div>
          <select
            value={filters.assignedTo}
            onChange={(e) => update({ assignedTo: e.target.value })}
            className="block w-full border-gray-300 rounded-md focus:ring-primary-500 focus:border-primary-500 sm:text-sm"
          >
            <option value="all">Alle medewerkers</option>
            {users.map((user) => (
              <option key={user.id} value={user.id}>
                {user.full_name}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
}
